var module = angular.module('octopusApp.environments', []);

module.config(function($stateProvider, stateHelperProvider, machineStateProvider) {

    $stateProvider.state('app.environments', {
        url: '/environments',
        template: stateHelperProvider.withBreadcrumb('Environments', '#/environments'),
        layout: {
            tab: 'environments',
            title: 'Environments'
        },
        defaultSubRoute: "app.environments.list"
    });

    $stateProvider.state("app.environments.list", {
        url: '',
        templateUrl: 'areas/environments/views/index.html',
        controller: 'EnvironmentIndexController'
    });

    $stateProvider.state("app.environments.new", {
        url: '/new',
        templateUrl: 'areas/environments/views/edit.html',
        controller: 'EnvironmentEditController',
        layout: {
            title: 'New Environments'
        }
    });


    {  //Machine Policies
        $stateProvider.state('app.environments.machinepolicies', {
            url: '/machinepolicies',
            template: stateHelperProvider.withBreadcrumb('Machine policies', '#/environments/machinepolicies'),
            layout: {
                title: 'Machine Policies'
            },
            defaultSubRoute: "app.environments.machinepolicies.list"
        });

        $stateProvider.state("app.environments.machinepolicies.list", {
            url: '',
            templateUrl: 'areas/environments/machinepolicies/views/index.html',
            controller: 'MachinePolicyIndexController',
            layout: {
                title: 'Machine Policies'
            }
        });

        $stateProvider.state("app.environments.machinepolicies.new", {
            url: '/new',
            templateUrl: 'areas/environments/machinepolicies/views/create.html',
            controller: 'MachinePolicyEditController',
            layout: {
                title: 'New Machine Policy'
            }
        });

        $stateProvider.state("app.environments.machinepolicies.edit", {
            url: '/:id',
            templateUrl: 'areas/environments/machinepolicies/views/edit.html',
            controller: 'MachinePolicyEditController',
            layout: {
                title: 'Edit Machine Policy'
            }
        });
    }

    { // Proxies
        $stateProvider.state('app.environments.proxies', {
            url: '/proxies',
            template: stateHelperProvider.withBreadcrumb('Proxies', '#/environments/proxies'),
            layout: {
                title: 'Proxies',
            },
            defaultSubRoute: "app.environments.proxies.list"
        });

        $stateProvider.state("app.environments.proxies.list", {
            url: '',
            templateUrl: 'areas/environments/proxies/views/index.html',
            controller: 'ProxyIndexController',
            layout: {
                title: 'Proxies'
            }
        });
        $stateProvider.state("app.environments.proxies.new", {
            url: '/new',
            templateUrl: 'areas/environments/proxies/views/edit.html',
            controller: 'ProxyEditController',
            layout: {
                title: 'New Proxy'
            }
        });

        $stateProvider.state("app.environments.proxies.edit", {
            url: '/:id',
            templateUrl: 'areas/environments/proxies/views/edit.html',
            controller: 'ProxyEditController',
            layout: {
                title: 'Edit Proxy'
            }
        });
    }

    { //machines
        $stateProvider.state("app.environments.machines", {
            url: '^/machines',
            template: stateHelperProvider.withBreadcrumb('Deployment Targets'),
            abstract: true
        });

        $stateProvider.state("app.environments.machines.new", {
            url: '/new',
            templateUrl: 'areas/environments/machines/discover.html',
            controller: 'MachineDiscoverController',
            layout: {
                title: 'New Deployment Target'
            }
        });

        $stateProvider.state("app.environments.machines.manual", {
            url: '/new/manual',
            templateUrl: 'areas/environments/machines/edit_machine.html',
            controller: 'MachineEditController',
            resolve: {
                machineState: function () { // needed because we share controller with the real edit
                    return null;
                }
            }

        });

        $stateProvider.state("app.environments.machines.edit", {
            url: '/:machineId',
            templateUrl: 'areas/environments/machines/machine_layout.html',
            controller: 'MachineLayoutController',
            resolve: {
                machineState: machineStateProvider.$get
            },
            defaultSubRoute: 'app.environments.machines.edit.details'
        });

        $stateProvider.state("app.environments.machines.edit.details", {
            url: '',
            templateUrl: 'areas/environments/machines/edit_machine.html',
            controller: 'MachineEditController',
            layout: {
                title: 'Edit Deployment Target',
                machineTab: 'settings'
            }
        });


        $stateProvider.state("app.environments.machines.edit.connectivity", {
            url: '/connection',
            templateUrl: 'areas/environments/machines/machine_connection.html',
            controller: 'MachineConnectionController',
            layout: {
                title: 'Deployment Target Connectivity',
                machineTab: 'connection'
            }
        });

        $stateProvider.state("app.environments.machines.edit.deployments", {
            url: '/deployments',
            templateUrl: 'areas/environments/machines/machine_deployments.html',
            controller: 'MachineDeploymentsController',
            layout: {
                title: 'Deployment History',
                machineTab: 'deployments'
            }
        });

        $stateProvider.state("app.environments.machines.edit.events", {
            url: '/events',
            templateUrl: 'areas/environments/machines/machine_events.html',
            controller: 'MachineEventsController',
            layout: {
                title: 'Event History',
                machineTab: 'events'
            }
        });
    }

    $stateProvider.state("app.environments.edit", {
        url: '/:id',
        templateUrl: 'areas/environments/views/edit.html',
        controller: 'EnvironmentEditController',
        layout: {
            title: 'Edit Environment'
        }
    });


});


//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/envrionments_module.js
// module id = 5177171895970868
// module chunks = 1